import {
  useGrippContext,
  useStorageKeys,
} from '@gripp/shared-logic';
import {
  Colors,
  ChevronLeftIcon,
  RegisterForm,
  colors,
  typography,
} from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AuthSplitLayout } from './authSplitLayout';

export default function Register() {
  const navigate = useNavigate();
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const { t } = useTranslation();

  const onVerify = async () => {
    await storageHandler.setItem(storageKeys.newRegister, 'register');
    navigate('/verify-auth-code');
  };

  const topBar = (
    <View>
      <Pressable
        style={styles.backNav}
        onPress={() => navigate('/login')}
        accessibilityRole="button"
        accessibilityLabel="Go back"
      >
        <ChevronLeftIcon size={24} color={Colors.role.textStrong} />
      </Pressable>
      <View style={styles.titleSection}>
        <Text style={styles.titleText}>{t('login.aboutYourself')}</Text>
        <Pressable onPress={() => navigate('/login')}>
          <Text style={styles.subtitleText}>
            {t('login.existingAccount')}
          </Text>
        </Pressable>
      </View>
    </View>
  );

  return (
    <AuthSplitLayout topBar={topBar}>
      <RegisterForm onVerify={onVerify} onBack={() => navigate('/login')} />
    </AuthSplitLayout>
  );
}

const styles = StyleSheet.create({
  backNav: {
    padding: 12,
    alignSelf: 'flex-start',
  },
  titleSection: {
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingBottom: 32,
  },
  titleText: {
    ...typography.display.largeEmphasised,
    textAlign: 'center',
    color: Colors.role.textStrong,
  },
  subtitleText: {
    ...typography.label.large,
    textAlign: 'center',
    color: Colors.role.textStrong,
    textDecorationLine: 'underline',
  },
});
